// extracted by mini-css-extract-plugin
export default {"card":"DocumentDeleteModal_card__1CXV6","footer":"DocumentDeleteModal_footer__eu9lO","button":"DocumentDeleteModal_button__-7iCL","heading":"DocumentDeleteModal_heading__oDVTe"};